import { render, staticRenderFns } from "./select-option.vue?vue&type=template&id=4836b4c3"
import script from "./select-option.vue?vue&type=script&lang=js"
export * from "./select-option.vue?vue&type=script&lang=js"
import style0 from "./select-option.vue?vue&type=style&index=0&id=4836b4c3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_6szsw7whnsew6zajutnmcgkloi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports